import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-ingresos',
  templateUrl: './ingresos.component.html',
  styleUrls: ['./ingresos.component.css']
})
export class IngresosComponent implements OnInit {
	@Input() parentescos
	@Input() ocupaciones
	@Input() tipoIngresos

	ingresosFormulario: FormGroup;

  constructor() { }

  ngOnInit(): void {
  }

}
